export const setSessionStorageItem = (item: string, itemValue: string): void => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(item, itemValue);
  }
};

export const getSessionStorageItem = (item: string): string | null => {
  if (typeof sessionStorage !== 'undefined') {
    return sessionStorage.getItem(item);
  }
  return null;
};
